// extracted by mini-css-extract-plugin
module.exports = {"container":"FileUploadContainer_container__1l8Xz"};